import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import SidebarItemForChoose from './SidebarItemForChoose';
import _variables from '@/styles/variables.scss';
export default {
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo,
    SidebarItemForChoose: SidebarItemForChoose
  },
  created: function created() {
    this.$store.dispatch('app/closeSideBar', {
      withoutAnimation: false
    }); // if(!this.choosen_router) {
    //   this.$store.dispatch('ChooseRouters', this.$store.state.permission.admin_routers[0]) // 左侧没有菜单时生成默认菜单
    // }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters(['sidebar'])), mapState({
    permission_routers: function permission_routers(state) {
      return state.permission.routers;
    },
    admin_routers: function admin_routers(state) {
      return state.permission.adminRouters;
    }
  })), mapState({
    choosen_router: function choosen_router(state) {
      return state.permission.choosenRouters;
    }
  })), {}, {
    // routes() {
    //   return this.$router.options.routes
    // },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
          path = route.path; // if set path, the sidebar will highlight the path you set

      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      // return !this.sidebar.opened
      return false;
    }
  })
};